export class ModelTime {
  constructor(
    public date: number,
    public runningTime: number,
    public preparationTime: number,
    public stopTime: number,
    public alarmTime: number,
    public maintenanceTime: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-time.ts